import { render, staticRenderFns } from "./DeleteConfirmationModal.vue?vue&type=template&id=e6b8a49c&"
import script from "./DeleteConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./DeleteConfirmationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports